import React, { useRef, useEffect, useState } from "react";
import ToggleFaq from "../ToggleFaq";
import faq from "./faqs.json";

const Edge: React.FC = () => {
  // Refs to access the DOM elements

  const gifImageRef = useRef<HTMLImageElement | null>(null);

  const [isGifLoaded, setIsGifLoaded] = useState(false);

  const handleGifLoad = () => {
    // Update state when GIF is loaded
    setIsGifLoaded(true);
  };

  useEffect(() => {
    const gif = gifImageRef.current;
    // Check if gifImageRef is set and assign the onload handler
    if (gif) {
      gif.onload = handleGifLoad;
    }

    // Cleanup function to avoid memory leaks
    return () => {
      if (gif) {
        gif.onload = null;
      }
    };
  }, []);

  return (
    <div>
      <main>
        <div className="bg-gt5">
          {/* hero section start from here */}
          <section className="px-4 py-8 relative md:py-20 text-left border-t border-white">
            <div className="md:max-w-6xl mx-auto px-4 max-w-xs">
              <div className="flex items-center absolute md:hidden">
                <span
                  className="bg-no-repeat bg-contain w-[18px] h-[18px] mr-2.5"
                  style={{
                    backgroundImage: "url(/assets/images/federal-bank.svg)",
                  }}
                ></span>
                <span className="text-[11px] font-medium leading-[13px] text-black40">
                  Issued by
                  <br /> Federal bank
                </span>
              </div>
              <div className="flex justify-end md:justify-center">
                {/* Placeholder Image */}
                <img
                  className="placeholder-image w-[170px] min-h-[259px] h-auto md:w-[288px]"
                  src={"/assets/images/edge-website/edge-card.png"}
                  alt="Placeholder"
                  style={{ display: isGifLoaded ? "none" : "block" }}
                />

                {/* GIF Image */}
                <img
                  ref={gifImageRef}
                  className=" gif-image w-[170px] min-h-[259px] h-auto md:w-[288px]"
                  src={"/assets/images/edge-website/edge-card.gif"}
                  alt="GIF"
                  style={{ display: isGifLoaded ? "block" : "none" }}
                />
              </div>
              <h1 className="text-[38px] font-bold leading-[44px] text-gt40 mb-4 mt-6 max-w-[266px] md:text-[48px] md:mb-5 md:text-center md:mt-8 md:max-w-2xl md:mx-auto">
                Assured 2% Cashback
              </h1>
              <p className="text-base font-normal leading-5 text-black20 mb-2 max-w-xs md:text-2xl md:mb-14 md:text-center md:max-w-full">
                On either Travel, Dining, or Shopping spends
              </p>

              <div className="flex justify-center items-center w-full">
                <div className="text-center">
                  <p className="text-xs leading-4 font-normal text-black75 mb-1">
                    Issued by
                  </p>
                  <span
                    className="bg-no-repeat bg-contain w-[86px] h-5 md:w-[86px] inline-block"
                    style={{
                      backgroundImage: "url(/assets/images/federal.png)",
                    }}
                  ></span>
                </div>
                <span className="mx-5 text-white/60 text-[26px] font-normal">
                  /
                </span>
                <div className="text-center">
                  <p className="text-xs leading-4 font-normal text-black75 mb-1">
                    Powered by
                  </p>
                  <span
                    className="bg-no-repeat bg-contain w-[49px] h-3.5 inline-block"
                    style={{
                      backgroundImage: "url(/assets/images/visa.png)",
                    }}
                  ></span>
                </div>
              </div>
            </div>
          </section>
          {/* hero section end here */}

          {/* reward pushed start from here */}
          <section className="px-4 py-6 bg-black5 md:py-28 text-left ">
            <div className="md:max-w-7xl max-w-md mx-auto">
              <div className="mb-12">
                <h2 className="text-[32px] font-bold leading-9 text-gt75 mb-2 md:text-[40px] md:leading-[44px] md:mb-0">
                  Your choice of extra rewards
                </h2>
                <span className="w-7 h-[7px] bg-gt75 inline-block md:w-16 md:h-2.5"></span>
              </div>
              <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-black5 py-6 px-5 rounded-2xl relative overflow-hidden mb-5">
                  <span className="text-lg font-normal leading-[22px] text-black20">
                    Upgrading your wardrobe?
                  </span>
                  <h3 className="text-[32px] font-semibold leading-[44px] text-[#2CB6A0] mb-1 tracking-[-4%]">
                    Switch to Shopping
                  </h3>
                  <p className="text-base font-normal leading-5 text-black40 mb-3">
                    2% cashback on fashion, groceries, <br />
                    electronics, and more
                  </p>
                  <span className="block absolute top-0 right-0 w-16 h-16 bg-[#54867D] rounded-full blur-3xl"></span>
                  <span className="block absolute bottom-0 left-0 w-16 h-16 bg-[#54867D] rounded-full blur-3xl"></span>
                  <span
                    className="absolute -bottom-4 -right-2.5 bg-no-repeat bg-contain w-[100px] h-[100px] opacity-20"
                    style={{
                      backgroundImage:
                        "url(/assets/images/edge-website/icons/shopping-mode.svg)",
                    }}
                  ></span>
                </div>
                <div className="bg-black5 py-6 px-5 rounded-2xl relative overflow-hidden mb-5">
                  <span className="text-lg font-normal leading-[22px] text-black20">
                    Planning a vacation?
                  </span>
                  <h3 className="text-[32px] font-semibold leading-[44px] text-[#9783DB] mb-1 tracking-[-4%]">
                    Switch to Travel
                  </h3>
                  <p className="text-base font-normal leading-5 text-black40 mb-3">
                    2% cashback on flights, trains, <br />
                    hotels, and more
                  </p>
                  <span className="block absolute top-0 right-0 w-16 h-16 bg-[#AEA3F1] rounded-full blur-3xl"></span>
                  <span className="block absolute bottom-0 left-0 w-16 h-16 bg-[#AEA3F1] rounded-full blur-3xl"></span>
                  <span
                    className="absolute -bottom-4 -right-2.5 bg-no-repeat bg-contain w-[100px] h-[100px] opacity-20"
                    style={{
                      backgroundImage:
                        "url(/assets/images/edge-website/icons/travel-plan.svg)",
                    }}
                  ></span>
                </div>
                <div className="bg-black5 py-6 px-5 rounded-2xl relative overflow-hidden mb-5">
                  <span className="text-lg font-normal leading-[22px] text-black20">
                    Night out?
                  </span>
                  <h3 className="text-[32px] font-semibold leading-[44px] text-[#F18973] mb-1 tracking-[-4%]">
                    Switch to Dining
                  </h3>
                  <p className="text-base font-normal leading-5 text-black40 mb-3">
                    2% cashback on food delivery, <br />
                    restaurants, and more
                  </p>
                  <span className="block absolute top-0 right-0 w-16 h-16 bg-[#A47267] rounded-full blur-3xl"></span>
                  <span className="block absolute bottom-0 left-0 w-16 h-16 bg-[#A47267] rounded-full blur-3xl"></span>
                  <span
                    className="absolute -bottom-4 -right-2.5 bg-no-repeat bg-contain w-[100px] h-[100px] opacity-20"
                    style={{
                      backgroundImage:
                        "url(/assets/images/edge-website/icons/dining-mode.svg)",
                    }}
                  ></span>
                </div>
              </div>
            </div>
          </section>
          {/* reward pushed end here */}

          {/* Get the Edge start from here */}
          <section className="w-full md:flex text-left">
            <div className="md:w-1/2 bg-black100 px-4 pt-8 md:py-28">
              <div className="max-w-[520px] mx-auto">
                <div>
                  <div className="mb-3 md:mb-8">
                    <h2 className="text-[32px] font-bold leading-9 text-gt40 md:text-[40px] md:leading-[44px]">
                      Rewards on every spend
                    </h2>
                    <span className="w-7 h-[7px] bg-gt50 inline-block md:w-11 md:h-2.5"></span>
                  </div>
                  <div className="flex items-center">
                    <span
                      className="bg-no-repeat bg-contain flex-shrink-0 w-6 h-6 mr-7 md:w-9 md:h-9 hidden md:block mb-2.5"
                      style={{
                        backgroundImage:
                          "url(/assets/images/edge-website/icons/star-point.svg)",
                      }}
                    ></span>
                    <div className="border-b border-black80 md:py-10 py-5">
                      <h3 className="text-xl font-semibold leading-8 text-gt40 md:text-[32px] md:leading-[44px]">
                        Assured 2% cashback
                      </h3>
                      <p className="text-base leading-6 md:text-base font-normal md:leading-8 text-black40">
                        On either shopping, travel, or dining
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <span
                      className="bg-no-repeat bg-contain flex-shrink-0 w-6 h-6 mr-7 md:w-9 md:h-9 hidden md:block mb-2.5"
                      style={{
                        backgroundImage:
                          "url(/assets/images/edge-website/icons/star-point.svg)",
                      }}
                    ></span>
                    <div className="border-b border-black80 md:py-10 py-5">
                      <h3 className="text-xl font-semibold leading-8 text-gt40 md:text-[32px] md:leading-[44px]">
                        Assured 0.4% cashback
                      </h3>
                      <p className="text-base leading-6 md:text-base font-normal md:leading-8 text-black40">
                        On your international transactions
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <span
                      className="bg-no-repeat bg-contain flex-shrink-0 w-6 h-6 mr-7 md:w-9 md:h-9 hidden md:block mb-2.5"
                      style={{
                        backgroundImage:
                          "url(/assets/images/edge-website/icons/star-point.svg)",
                      }}
                    ></span>
                    <div className="md:py-10 py-5">
                      <h3 className="text-xl font-semibold leading-8 text-gt40 md:text-[32px] md:leading-[44px]">
                        Free lounge access
                      </h3>
                      <p className="text-base leading-6 md:text-base font-normal md:leading-8 text-black40">
                        1 free lounge access every quarter
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 bg-gt5 md:py-28 py-8 px-8 flex w-full">
              <div className="lg:pl-20 md:w-[522px] max-w-md mx-auto md:mx-0 md:max-w-full">
                <div className="mb-3 md:mb-8">
                  <h2 className="text-[32px] font-bold leading-9 text-gt40 md:text-[40px] md:leading-[44px]">
                    No hidden fees
                  </h2>
                  <span className="w-7 h-[7px] bg-gt50 inline-block md:w-11 md:h-2.5"></span>
                </div>
                <img
                  className="md:w-full"
                  src={"/assets/images/edge-website/annual-free-detail.png"}
                  width="276"
                  alt="Annual Free"
                />
              </div>
            </div>
          </section>
          {/* Get the Edge end here */}

          {/* Take control start from here */}
          <section className="md:py-36 py-10 px-4 bg-black5 text-left">
            <div className="md:max-w-7xl mx-auto max-w-md relative">
              <div className="md:flex md:justify-between md:items-center">
                <div className="w-full md:w-2/5 mb-8 md:mb-0">
                  <h2 className="text-[32px] font-bold leading-9 text-gt75 mb-2 md:text-[40px] md:leading-[44px] md:mb-2">
                    Take control of the <br />
                    out-of-control
                  </h2>
                  <span className="w-8 h-[7px] bg-gt60 inline-block md:w-14 md:h-2.5 mb-8"></span>
                  <p className="text-base font-medium leading-5 text-gt40 md:text-2xl md:leading-8">
                    Get Insights on both UPI and <br />
                    credit card spends
                  </p>
                </div>
                <div className="w-full md:w-[46%] pr-1 pb-4 md:pb-0 md:pr-10">
                  <img
                    className="w-full h-auto"
                    src={"/assets/images/edge-website/tracking-upi.png"}
                    alt="Tracking UPI"
                  />
                </div>
              </div>
            </div>
          </section>
          {/* Take control end here */}

          {/* 1-click card start from here */}
          <section className="relative md:py-44 py-9 px-4 text-left">
            <div className="md:max-w-7xl mx-auto max-w-md">
              <div>
                <div className="mb-8 md:mb-24">
                  <h2 className="text-[32px] font-bold leading-9 text-gt75 mb-2 md:text-[40px] md:leading-[44px] md:mb-2">
                    1-click card controls
                  </h2>
                  <span className="w-8 h-[7px] bg-gt60 inline-block md:w-14 md:h-2.5"></span>
                </div>
                <div className="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                  <div className="flex items-center">
                    <span className="w-11 h-11 md:w-[88px] md:h-[88px] mr-3.5 bg-gt15 rounded-full border-[2px] border-gt25 flex-shrink-0 flex items-center justify-center">
                      <span
                        className="bg-no-repeat bg-contain w-6 h-6 md:w-11 md:h-11"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/copy.svg)",
                        }}
                      ></span>
                    </span>
                    <p className="text-sm font-medium leading-4 text-black20 md:text-[23px] md:leading-[30px]">
                      Copy number
                    </p>
                  </div>
                  <div className="flex items-center">
                    <span className="w-11 h-11 md:w-[88px] md:h-[88px] mr-3.5 bg-gt15 rounded-full border-[2px] border-gt25 flex-shrink-0 flex items-center justify-center">
                      <span
                        className="bg-no-repeat bg-contain w-6 h-6 md:w-11 md:h-11"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/snowflake-freeze.svg)",
                        }}
                      ></span>
                    </span>
                    <p className="text-sm font-medium leading-4 text-black20 md:text-[23px] md:leading-[30px]">
                      Freeze Card &nbsp;&nbsp;
                    </p>
                  </div>
                  <div className="flex items-center">
                    <span className="w-11 h-11 md:w-[88px] md:h-[88px] mr-3.5 bg-gt15 rounded-full border-[2px] border-gt25 flex-shrink-0 flex items-center justify-center">
                      <span
                        className="bg-no-repeat bg-contain w-6 h-6 md:w-11 md:h-11"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/lock-with-pin.svg)",
                        }}
                      ></span>
                    </span>
                    <p className="text-sm font-medium leading-4 text-black20 md:text-[23px] md:leading-[30px]">
                      Reset PIN
                    </p>
                  </div>
                  <div className="flex items-center">
                    <span className="w-11 h-11 md:w-[88px] md:h-[88px] mr-3.5 bg-gt15 rounded-full border-[2px] border-gt25 flex-shrink-0 flex items-center justify-center">
                      <span
                        className="bg-no-repeat bg-contain w-6 h-6 md:w-11 md:h-11"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/manage-transactions.svg)",
                        }}
                      ></span>
                    </span>
                    <p className="text-sm font-medium leading-4 text-black20 md:text-[23px] md:leading-[30px]">
                      Card Limits
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* 1-click card end here */}

          {/* FAQs start here */}
          <div className="py-12 sm:py-12 px-3">
            <h3 className="text-center text-lg text-white sm:text-4xl font-semibold mb-3 sm:mb-9">
              Frequently asked questions
            </h3>

            <div className="max-w-[1200px] mx-auto">
              <ToggleFaq questions={faq} />
            </div>
          </div>
          {/* FAQs end here */}

          {/* footer start from here */}
          <footer>
            <div className="md:flex md:items-center text-left">
              <a
                href="https://www.federalbank.co.in/documents/10180/810691487/Federal-Edge+Credit+Card+Terms+[…]s.pdf/8bc20f71-a2ab-cb78-ddc1-7187fac04148?t=1712823203052"
                className="w-full py-5 md:pl-28 pl-8 pr-8 bg-sf60 text-white text-lg leading-8 font-semibold flex justify-between items-center border-b md:border-r border-sf100 md:w-1/2"
              >
                <span>Terms & Conditions</span>
                <span
                  className="bg-no-repeat bg-contain w-[12px] h-[18px] inline-block"
                  style={{
                    backgroundImage:
                      "url(/assets/images/edge-website/icons/right-chevron.svg)",
                  }}
                ></span>
              </a>
              <a
                href="https://www.federalbank.co.in/documents/10180/810691487/MITC+Federal+Edge+Co-Branded+Cr[…]d.pdf/328df5a9-1a4a-4a4a-7395-fff737ad2c81?t=1727954959443"
                className="w-full py-5 px-8 bg-sf60 text-white text-lg leading-8 font-semibold flex justify-between items-center border-b md:border-r border-sf100 md:w-1/2"
              >
                <span>Key Fact Statement</span>
                <span
                  className="bg-no-repeat bg-contain w-[12px] h-[18px] inline-block"
                  style={{
                    backgroundImage:
                      "url(/assets/images/edge-website/icons/right-chevron.svg)",
                  }}
                ></span>
              </a>
              <a
                href="https://www.federalbank.co.in/documents/10180/810691487/KFS+Federal+Edge+Co-Branded+Cre[…]d.pdf/eedb7355-cfcc-0664-316d-e02f8c33b836?t=1727954699296"
                className="w-full py-5 md:pr-28 pr-8 pl-8 bg-sf60 text-white text-lg leading-8 font-semibold flex justify-between items-center border-b border-sf100 md:w-1/2"
              >
                <span>*All Benefits</span>
                <span
                  className="bg-no-repeat bg-contain w-[12px] h-[18px] inline-block"
                  style={{
                    backgroundImage:
                      "url(/assets/images/edge-website/icons/right-chevron.svg)",
                  }}
                ></span>
              </a>
            </div>
            <div className="md:max-w-6xl max-w-md mx-auto px-4 text-left">
              <div className="md:flex pt-10 md:pt-[68px]">
                <div className="md:w-1/2 md:mt-10">
                  <div className="max-w-[29rem]">
                    <span
                      className="bg-no-repeat bg-contain w-[286px] h-[37px] inline-block mb-4 lg:w-[435px] lg:h-[57px]"
                      style={{
                        backgroundImage:
                          "url(/assets/images/edge-website/bank-edge.png)",
                      }}
                    ></span>
                    <p className="py-2 border-y border-[#ABABAB] text-black20 text-xl font-normal leading-[22px] mb-6 md:py-3 md:text-2xl md:leading-[30px] md:mb-9">
                      Built with trust at its core
                    </p>
                    <p className="text-black20 text-base font-normal leading-[22px] mb-7 md:text-2xl md:leading-[30px] md:mb-0">
                      Use the Edge Federal Bank Credit Card on Jupiter, the app
                      for everything money: <br />
                      Spend. Track. Save. Invest
                    </p>
                  </div>
                </div>
                <div className="text-center md:w-1/2">
                  <img
                    className="inline-block w-[300px] lg:w-[400px]"
                    src={"/assets/images/edge-website/edge-visa-mockup.png"}
                    width="300"
                    alt="footer"
                  />
                </div>
              </div>
            </div>
            <div className="w-full -mt-10 md:-mt-16">
              <img
                loading="lazy"
                src={"/assets/images/bg_footer.svg"}
                alt="bg_footer"
                className="relative w-full mx-auto lg:static h-[116px] object-cover"
                style={{ bottom: -5 }}
              />
            </div>
            <div
              className="relative px-4 pb-6 text-white bg-sf50"
              style={{ top: -1 }}
            >
              <div className="md:max-w-6xl max-w-md mx-auto px-4">
                <p className="pb-2 text-xs font-normal leading-4 md:text-base md:leading-7 md:text-left">
                  The Edge brand is owned by Europa Neo Marketing Pvt Limited
                  ("ENMPL"). ENMPL has partnered with Federal Bank for the Edge
                  Federal Bank Visa Credit card ("Credit Card"). The sole issuer
                  of the Credit Card is Federal Bank. ENMPL acts exclusively as
                  a co-branding partner and is responsible only for promoting
                  the Credit Card in the capacity of a co-branding partner.
                  ENMPL does not have visibility into or any role in, the
                  approval process for Credit Card applications, which are
                  solely governed by Federal Bank's eligibility criteria and
                  Credit Card policy. Additionally, ENMPL does not have any role
                  and visibility to Credit Card details, Credit Card management,
                  Credit Card transaction data and rewards and its role is
                  strictly limited only to promote the Credit Card on various
                  platforms.
                </p>
              </div>
            </div>
          </footer>
          {/* footer  end here */}
        </div>
      </main>
    </div>
  );
};
export default Edge;
